<template>
    <UserPageLayout>
        <AuthPopup
            v-if="showAuthPopup"
            :login-title="[$t('top_right_menu_login')]"
            :login-underline="$t('playlive_login_header')"
            :webview-redirect-to="createWebviewRedirectTo()"
            :show-close-button="false"
            :prevent-newsletter-popup="true"
            @login-success="loginSuccess"
            @register-success="registerSuccess"
        />
    </UserPageLayout>
</template>

<script>
import UserPageLayout from '@/layouts/UserPage'
import UserService from '@/lib/user'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'

export default {
    mixins: [AuthPopupMixin],

    components: {
        UserPageLayout,
        AuthPopup
    },

    mounted: function () {
        const userService = new UserService()

        userService
            .validateToken()
            .then(() => {
                this.afterLoginSuccess()
            })
            .catch(() => {
                this.showAuthPopup = true
            })
    },

    methods: {
        afterLoginSuccess() {
            this.$store.commit('toggleMainLoader', true)

            if (!this.$route.query.path) {
                return this.$router.replace({
                    name: 'my-quiz'
                })
            }

            if (this.$route.query.live) {
                location.href = atob(this.$route.query.path)
            } else {
                const routes = this.$router.options.routes
                let path = atob(this.$route.query.path)
                let pathName = path.split('?')[0] || ''
                let found = routes.find(route => route.path === pathName)

                const userService = new UserService()

                if (found && typeof found.beforeEnter === 'function') {
                    if (found.beforeEnter.name === 'requiredLoggedIn' && !userService.isLoggedIn()) {
                        this.showAuthPopup = true
                        return
                    }
                }

                this.$router.replace({
                    path
                })
            }
        },

        registerSuccess() {
            if (!this.$route.query.path) {
                return this.$router.replace({
                    name: 'my-quiz',
                    query: {
                        newsletter: 1
                    }
                })
            }
        }
    }
}
</script>
